import { render, staticRenderFns } from "./CustomerReportFilter.vue?vue&type=template&id=2264cba5"
import script from "./CustomerReportFilter.vue?vue&type=script&lang=js"
export * from "./CustomerReportFilter.vue?vue&type=script&lang=js"
import style0 from "./CustomerReportFilter.vue?vue&type=style&index=0&id=2264cba5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports